<template>
<div class="pa-3">
    <v-toolbar flat dense dark color="primary">
      <v-toolbar-title>
        Komentarze
      </v-toolbar-title>
    </v-toolbar>
    <div v-if="isActiveRunnerTrainer || isActiveRunner" class="pa-3">
      <plan-comment-form @success="addComment" :month="month"></plan-comment-form>
    </div>
    <v-data-iterator
      class="comments"
      :items="commentsList"
      :pagination.sync="context"
      :rows-per-page-items="perPageOptions"
      :total-items="rowsTotal"
      :loading="loading"
      content-tag="v-list"
      :content-props="{twoLine: true}"
    >
      <template slot="item" slot-scope="props">
        <plan-comment v-if="!props.item.edit" :comment="props.item" @change-comment="changeComment(props.item)" @remove-comment="removeComment(props.item)"></plan-comment>

        <v-list-tile class="" @click="" v-if="props.item.edit">
          <v-list-tile-content class="d-block">
            <plan-comment-form :comment="props.item" @success="props.item.edit = false; refresh()"></plan-comment-form>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider/>
      </template>
    </v-data-iterator>
</div>
</template>

<script>
import {fetchComments, deleteComment} from './api'
import {ListMixin} from '@/utils/ListMixin'
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
import iziToast from 'izitoast'

import PlanComment from './PlanComment'
import PlanCommentForm from './PlanCommentForm'

export default {
  components: {PlanComment, PlanCommentForm},
  mixins: [ListMixin],
  props: {
    month: {
      type: Object
    }
  },
  data () {
    return {
      loading: true,
      commentsList: []
    }
  },
  computed: {
    ...mapState(['runner']),
    ...mapGetters(['isActiveRunnerTrainer', 'isActiveRunner'])
  },
  created () {
    this.fetchPlanComments()
  },
  watch: {
    '$route': 'fetchPlanComments',
    context: {
      handler () {
        this.fetchPlanComments()
      },
      deep: true
    }
  },
  methods: {
    refresh: _.debounce(function () {
      this.fetchPlanComments()
    }, 400),
    fetchPlanComments () {
      let params = this.prepareParams()
      let promise = fetchComments(this.runner, params)
      return promise.then(this.enhanceListData).then((data) => {
        this.loading = false
        this.commentsList = data
        return data
      })
    },
    addComment (item) {
      this.fetchPlanComments()
    },
    changeComment (item) {
      this.$set(item, 'edit', true)
    },
    removeComment (item) {
      this.$root.$confirm('Usuń komentarz', 'Czy na pewno usunąć ten komentarz?', {confirmText: 'Usuń', color: 'error'}).then((willDelete) => {
        if (willDelete) {
          let promise = deleteComment(this.runner, item)
          return promise.then(() => {
            this.refresh()
            iziToast.show({
              message: 'Komentarz został usunięty',
              color: 'green'
            })
          }).catch(() => {
            iziToast.show({
              message: 'Nie udało się usunąć komentarza.',
              color: 'red'
            })
          })
        }
      })
    }
  }
}
</script>
<style>
.comments .v-list--two-line .v-list__tile {
  min-height: 90px;
  height: auto;
}
.comments .v-list--two-line .v-list__tile__content {
  min-height: 90px;
  height: auto;
}
.comments .v-list--two-line .v-list__tile__title {
  height: auto;
}
.comments .v-list--two-line .v-list__tile__action--stack {
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/plan/PlanComments.vue